import React from "react";

// reactstrap components
import {Button, Container} from "reactstrap";
import addedStyle from "../styles/css/style-react.module.css"
import CarouselEngine2 from "./CarouselEngine2";

// core components

const Carousel = () => {
    return (
        <>
            <div className="">
                <CarouselEngine2/>
            </div>
        </>
    );
}

export default Carousel;
